import { createContext, useContext } from 'react';
import { AvatarShape, AvatarSizeType } from '../types';

interface AvatarContextType {
    size: AvatarSizeType;
    nameValue: string;
    shape: AvatarShape;
    setVideoAutoPlay: React.Dispatch<React.SetStateAction<boolean>>;
    videoAutoPlay: boolean;
}

export const AvatarContext = createContext<AvatarContextType>({} as AvatarContextType);

export const useAvatarContext = () => {
    const context = useContext(AvatarContext);
    return context;
};
